<template>
  <div
    class="inspection-window"
    :style="{ top: `${position.top}px`, left: `${position.left}px` }"
    @click.self="onClose"
  >
    <div class="window-header">
      <h3>{{ title }}</h3>
      <p v-if="subtitle" class="subheader">{{ subtitle }}</p>
    </div>
    <div class="window-content">
      <div v-if="localForm.inspectionTypeId === hundredHourInspectionId">
        <div class="form-group-horizontal">
          <div class="form-field">
            <label for="lastTach">Last Tach</label>
            <input
              type="number"
              id="lastTach"
              v-model="localForm.lastTach"
              step="0.1"
              class="form-control"
              :disabled="mode === 'view'"
              @change="
                mode === 'update' ? onTachChange(localForm.lastTach) : null
              "
            />
          </div>
          <div class="form-field">
            <label for="nextTach">Next Tach</label>
            <input
              type="number"
              id="nextTach"
              v-model="localForm.nextTach"
              step="0.1"
              class="form-control"
              :disabled="mode === 'view'"
            />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="form-group-horizontal">
          <div class="form-field">
            <label for="lastDate">Date Completed</label>
            <input
              type="date"
              id="lastDate"
              v-model="localForm.lastDate"
              class="form-control"
              :disabled="mode === 'view'"
              @change="
                mode === 'update' ? onDateChange(localForm.lastDate) : null
              "
            />
          </div>
          <div class="form-field">
            <label for="nextDate">Next Due Date</label>
            <input
              type="date"
              id="nextDate"
              v-model="localForm.nextDate"
              class="form-control"
              :disabled="mode === 'view'"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="action-buttons">
      <template v-if="mode === 'view'">
        <HiloButton label="Close" styleType="grey" @click="onClose" />
      </template>
      <template v-else-if="mode === 'update'">
        <HiloButton label="Save" styleType="green" @click="handleSave" />
        <HiloButton label="Cancel" styleType="grey" @click="onClose" />
      </template>
    </div>
  </div>
</template>

<script>
import HiloButton from "@/components/HiloComponents/HiloButton.vue";
import dayjs from "dayjs";

export default {
  components: { HiloButton },
  props: {
    mode: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    form: {
      type: Object,
      required: true,
    },
    triggerRect: {
      type: Object,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onSave: {
      type: Function,
      required: false,
    },
    onDateChange: {
      type: Function,
      required: false,
    },
    onTachChange: {
      type: Function,
      required: false,
    },
    hundredHourInspectionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      position: { top: 0, left: 0 },
    };
  },
  computed: {
    localForm() {
      return {
        ...this.form,
        lastDate: this.formatDate(this.form.lastDate),
        nextDate: this.formatDate(this.form.nextDate),
      };
    },
  },
  mounted() {
    this.calculatePosition();
  },
  methods: {
    handleSave() {
      if (this.onSave) {
        this.onSave(this.localForm);
      }
    },
    formatDate(date) {
      return date ? dayjs(date).format("YYYY-MM-DD") : "";
    },
    calculatePosition() {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const windowWidth = 350;
      const windowHeight = 300;
      const scrollOffsetY = document.documentElement.scrollTop;
      const scrollOffsetX = document.documentElement.scrollLeft;

      let top = this.triggerRect.bottom + scrollOffsetY;
      let left = this.triggerRect.left + scrollOffsetX;

      if (left + 210 + windowWidth > viewportWidth) {
        left = viewportWidth - windowWidth - 250;
      } else if (left < 0) {
        left = 10;
      }

      if (top + windowHeight > viewportHeight) {
        top = viewportHeight - windowHeight - 10;
      } else if (top < 0) {
        top = 10;
      }

      this.position = { top, left };
    },
  },
};
</script>

<style scoped>
.inspection-window {
  position: absolute;
  background-color: #d9d9d9;
  border: 1px solid lightgrey;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 100;
  max-width: 350px;
}

.window-header {
  text-align: center;
  margin-bottom: 15px;
}

.window-header h3 {
  margin: 0;
  font-weight: bold;
}

.subheader {
  text-align: center;
  font-size: 14px;
  color: #555;
}

.window-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group-horizontal {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.form-field {
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;
}

.form-control {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.action-buttons {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
